export default __webpack_public_path__ + "static/media/Dmitri-Particle_0004_IceSpike3.1257d647.png";